import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { gigTemplatesQueryOptions } from "api/queries/gigPostTemplates";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location: Pick<ForManagerLocationDetail, "id"> };

export const gigTemplatesQuery = ({ location }: QueriesInput) =>
  gigTemplatesQueryOptions({ location_id: location.id }, { query: { staleTime: Number.POSITIVE_INFINITY } });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [gigTemplatesQuery(input)];
